 
import React, { useEffect, useMemo, useRef, useState } from "react";
import objectPath from "object-path";
import { useHtmlClassService } from "../../_core/MetronicLayout";
import { Topbar } from "./Topbar";
import { HeaderMenuWrapper } from "./header-menu/HeaderMenuWrapper";
import SVG from "react-inlinesvg";
import { AnimateLoading } from "../../../_partials/controls";
import { useSelector } from "react-redux";
import { getBaseImageURL } from "../../../../helpers";
import "./Header.scss";
import { Link, useLocation } from "react-router-dom";
import { toAbsoluteUrl } from "../../../_helpers";
import { usePageTitle } from "./PageTitle";
import { getSidebarData } from "../sidebar/SidebarData";

export function Header({ setMobileMenu, mobileMenu }) {
  const [logo, setLogo] = useState();
  const uiService = useHtmlClassService();
  const location = useLocation();
  const { siteLogo } = useSelector((state) => state.settings?.generalSettings);
  const { currentPermissions } = useSelector((state) => state.role);
  const { generalSettings } = useSelector((state) => state.settings);
  const { taxonomy } = useSelector((state) => state?.taxonomy);
  const { favIcon, siteName } = useSelector(
    (state) => state.settings?.generalSettings
  );
  const globalImagePath = useRef(getBaseImageURL());

  const fav = document.getElementById("favicon");

  useEffect(() => {
    if (siteLogo) {
      setLogo(siteLogo);
    }
  }, [siteLogo]);

  const toggleMobileMenu = () => {
    setMobileMenu(!mobileMenu);
  };

  if (!favIcon) {
    fav.setAttribute("href", "%PUBLIC_URL%/media/logos/favicon.ico");
  } else {
    fav.setAttribute("href", `${globalImagePath.current}${favIcon}`);
  }
  document.title = `Welcome to ${siteName}`;

  const getPageTitle = () => {
    const sidebarData = useMemo(() => {
      return getSidebarData(currentPermissions, generalSettings, taxonomy);
    }, [currentPermissions, generalSettings, taxonomy]);

    const sortedData = [...sidebarData].sort(
      (a, b) => b.path.length - a.path.length
    );

    for (const item of sortedData) {
      if (location.pathname.startsWith(item.path)) {
        return item.title;
      }

      if (item.subItems && item.subItems.length > 0) {
        for (const subItem of item.subItems) {
          if (location.pathname.startsWith(subItem.path)) {
            return item.title;
          }
        }
      }
    }
    return "Dashboard";
  };

  const pageTitle = getPageTitle();

  return (
    <>
      {/*begin::Header*/}
      <div className={`header-wrapper bg-white container-fluid my-2 px-4`}>
        <div className="header-blur-effect" />
        {/*begin::Container*/}
        <div
          className={`header-content d-flex align-items-center justify-content-between position-relative`}>
          <div className="position-absolute top-0 w-100 left-0">
            <AnimateLoading />
          </div>
          {/*begin::Header Menu Wrapper*/}
          {/* {layoutProps.menuHeaderDisplay && <HeaderMenuWrapper />} */}

          {/*end::Header Menu Wrapper*/}
          <div className="me-auto d-flex justify-content-between align-items-center py-2">
            <h4
              style={{ color: "#003861" }}
              className="d-xl-block d-none fw-bolder m-0">
              {pageTitle}
            </h4>
            <h3 className="d-md-none fw-bolder m-0 cursor-pointer">
              <Link to="/" className="logo">
                <img
                  alt="logo"
                  src={`${globalImagePath.current}${logo}`}
                  style={{ height: "25px" }}
                  className="object-fit-contain"
                />
              </Link>
            </h3>
          </div>
          {/*begin::Topbar*/}
          <Topbar />
          <div
            className="d-flex bg-input-bg-clr gap-3 align-items-center px-4 py-2 ms-2 rounded-fix cursor-pointer d-block d-md-none"
            onClick={() => toggleMobileMenu()}>
            <span className="svg-icon svg-icon-1x svg-icon-primary d-block">
              <SVG
                src={toAbsoluteUrl(
                  "media/svg/icons/NewDashboard/menu-icon.svg"
                )}></SVG>
            </span>
          </div>
          {/*end::Topbar*/}
        </div>
        {/*end::Container*/}
      </div>

      {/*end::Header*/}
    </>
  );
}
